<div
    class="box-old-version"
    *ngIf="showOldVersion"
>
    <div class="old-version-box-notification">
        کاربر گرامی، به دلیل قدیمی بودن نسخه اندروید دستگاه شما، لطفا جهت نمایش و
    خرید محصولات، از وبسایت نوار استفاده نمایید.
    </div>
    <div
        class="old-version-button"
        (click)="goToWeb()"
    >
        <navaar-button
            [type-button]="'button'"
            [color-name]="'yellow-icon'"
        >
            <span class="text-more">ورود به وبسایت نوار</span>
            <navaar-chevron-icon class="list-more"></navaar-chevron-icon>
        </navaar-button>
    </div>
</div>
<div
    class="container-category"
    *ngIf="!showOldVersion"
>
    <div id="wrapper">
        <div id="search-container">
            <div id="inner-search-container">
                <img src="assets/icon-new/search.svg">
                <input
                    readonly
                    (click)="search()"
                    type="search"
                    placeholder="جست‌وجو در میان کتاب‌ها، نویسندگان، گویندگان و..."
                    tabindex="-1"
                >
            </div>
        </div>
        <div id="contaienr-main-category">
            <div id="inner-contaienr-main-category">
                <ng-template
                    ngFor
                    [ngForOf]="genres"
                    let-genre
                    let-i="index"
                >
                    <div
                        (click)="selectedCategory(genre.identifier, i)"
                        [class.selected]="i == selectedTab"
                    >
                        <div [style.marginTop.px]="
                                                      genre.contentType == productType.Capsule ||
                                                      genre.contentType == productType.AudioSeries
                                                        ? 6
                                                        : 0
                                                    ">
                            <ng-container [ngSwitch]="genre.contentType">
                                <ng-template [ngSwitchCase]="productType.AudioBook">
                                    <navaar-book-icon [with-circle]="false"></navaar-book-icon>
                                </ng-template>
                                <ng-template [ngSwitchCase]="productType.Capsule">
                                    <navaar-book-summary-icon [with-circle]="false"></navaar-book-summary-icon>
                                </ng-template>
                                <ng-template [ngSwitchCase]="productType.AudioSeries">
                                    <navaar-serial-icon [with-circle]="false"></navaar-serial-icon>
                                </ng-template>
                                <ng-template [ngSwitchCase]="productType.Podcast">
                                    <navaar-podcast-icon [with-circle]="false"></navaar-podcast-icon>
                                </ng-template>
                            </ng-container>
                        </div>
                        <p [textContent]="genre.name"></p>
                    </div>
                </ng-template>
            </div>
            <div class="triangle-arrow">
                <navaar-traingles-icon></navaar-traingles-icon>
            </div>
            <div
                class="container-list-category"
                [@.disabled]="clpService.isBackFromItem"
            >
                <div [@listAnimation]="items">
                    <ng-template
                        ngFor
                        [ngForOf]="items"
                        let-item
                        let-i="index"
                        let-c="count"
                        [ngForTrackBy]="trackByFn"
                    >
                        <div
                            class="item"
                            [attr.tabindex]="i"
                            (click)="navigateToCat(item.name, item.identifier, item.contentType, i, c)"
                        >
                            <img
                                src="assets/img/small-place-holder.jpg"
                                [lazySrc]="environment.imageUrl + item.imageUrl"
                                lazySrcVisible="ClpVisible"
                                loading="lazy"
                            >
                            <p [textContent]="item.name"></p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
